import { render } from "./Day.vue?vue&type=template&id=31d65cbc&scoped=true"
import script from "./Day.vue?vue&type=script&lang=js"
export * from "./Day.vue?vue&type=script&lang=js"

import "./Day.vue?vue&type=style&index=0&id=31d65cbc&scoped=true&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d65cbc"]])

export default __exports__